<template>
  <div>
    <div>
      <div class="title">
        <van-icon name="arrow-left" class="lefticon" @click="goBack()" />
        <p>{{ msgs.banben }}</p>
      </div>
      <div class="page-role">
        <div class="pxui-area">
          <h1>
            <strong class="pxui-color-red">{{ msgs.banben }}</strong>
            <span>{{ displayPrice }}元{{ msgs.pricetype | filterPrice }}</span>
          </h1>
          <p v-html="msgs.desc"></p>
        </div>
      </div>
      <div class="team-discount-banner qualified" v-if="teamDiscountQualified">
        当前组队已达标，本次下单将自动享受优惠价
      </div>
      <div class="team-discount-banner" v-else-if="teamDiscountTeam">
        你已加入组队，满3人后下单可自动享受优惠价
      </div>
    </div>

    <div class="paper-information">
      <div class="info-row">
        <span>论文标题：</span>
        <input
          type="text"
          name="title"
          placeholder="请输入论文题目"
          v-model.trim="title"
          maxlength="200"
          @input="handleTitleInput"
        />
      </div>
      <div class="info-row">
        <span>作者姓名：</span>
        <input
          type="text"
          name="author"
          placeholder="请输入论文作者"
          v-model.trim="author"
          maxlength="150"
          :readonly="writerAnonymous"
          @input="handleAuthorInput"
        />
        <label class="anonymous-toggle">
          <input type="checkbox" :checked="writerAnonymous" @change="toggleAnonymous" />
          <em>匿名</em>
        </label>
      </div>
      <p class="field-tip">勾选匿名送检后，报告中作者显示为***，且无法识别自引。</p>

      <div class="checkdbs-box" v-if="showCheckDbs" @click="confirmToggleCheckDbs">
        <div class="checkdbs-check" :class="{ checked: checkDbsChecked }"></div>
        <div class="checkdbs-body">
          <div class="checkdbs-title">{{ checkDbsLabel }}</div>
          <div class="checkdbs-tip">如不清楚该选项请按默认提交即可</div>
        </div>
      </div>

      <div class="info-row" v-if="showPublishDate">
        <span>发表时间：</span>
        <input
          type="text"
          placeholder="论文发表时间"
          v-model="endDate"
          readonly
          @click="selectDate"
        />
      </div>

      <van-popup v-model="show" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="sureDate"
          @cancel="noDate"
        />
      </van-popup>

      <div class="uploads">
        <ul class="upload-tabs">
          <li
            v-for="item in uploadmode"
            :key="item.id"
            :class="current === item.id ? 'active' : ''"
            @click="changeuploads(item.id)"
          >
            {{ item.name }}
          </li>
        </ul>

        <div class="upload-card" v-if="current === 1">
          <van-uploader accept=".doc,.docx" :after-read="afterRead" class="upload-uploader">
            <div class="upload-panel">
              <div class="upload-panel-icon">DOC</div>
              <div class="upload-panel-body">
                <div class="upload-panel-title">
                  {{ uploadname || "点击上传论文文件" }}
                </div>
                <div class="upload-panel-tip">
                  支持 doc、docx 格式，建议直接上传论文原文档
                </div>
              </div>
              <div class="upload-panel-action">
                {{ uploadname ? "重新选择" : "选择文件" }}
              </div>
            </div>
          </van-uploader>

          <div class="upload-file-meta" v-if="uploadname">
            <span class="upload-file-name">{{ uploadname }}</span>
            <span class="upload-file-status">{{ file_id ? "上传成功" : "上传中" }}</span>
          </div>
        </div>

        <textarea
          id="context"
          placeholder="请输入需要查重的论文内容，建议不少于100字"
          v-if="current === 0"
          class="wend-text"
          v-model="content"
        ></textarea>

        <p class="wjgs" v-if="current === 1">
          支持文档格式：(<span>doc, docx</span>)
        </p>

        <button id="subbutt" :disabled="submitLoading" @click="toPay(current)" type="button">
          {{ submitLoading ? "提交中..." : "下一步" }}
        </button>
        <div style="height: 3rem"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import {
  getCheckDbsConfig,
  getPriceUnitSuffix,
  isPublishDateRequired,
} from "@/utils/order";

export default {
  data() {
    return {
      msgs: {},
      current: 1,
      uploadmode: [
        { id: 1, name: "上传文件(推荐)" },
        { id: 0, name: "粘贴文本" },
      ],
      title: "",
      author: "",
      preservedAuthor: "",
      writerAnonymous: false,
      uploadname: "",
      content: "",
      formData: {},
      payMsg: {},
      file_id: "",
      show: false,
      minDate: new Date(2000, 0, 1),
      currentDate: new Date(),
      endDate: "",
      showCheckDbs: false,
      checkDbsLabel: "",
      checkDbsValue: "",
      checkDbsChecked: false,
      showPublishDate: false,
      submitLoading: false,
      teamDiscountTeam: null,
      teamDiscountQualified: false,
    };
  },
  computed: {
    maxDate() {
      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    displayPrice() {
      return this.msgs.price || "";
    },
  },
  created() {
    this.msgs = this.$route.query || {};
    this.syncExtraFields();
    this.loadTeamDiscountStatus();
  },
  filters: {
    filterPrice(value) {
      return getPriceUnitSuffix(value);
    },
  },
  methods: {
    syncExtraFields() {
      const category = {
        id: this.msgs.id,
        cid: this.msgs.cid,
        name: this.msgs.banben,
      };
      const config = getCheckDbsConfig(category);

      this.showPublishDate = isPublishDateRequired(category);

      if (config) {
        this.showCheckDbs = true;
        this.checkDbsLabel = config.label;
        this.checkDbsChecked = config.checked;
        this.checkDbsValue = config.checked ? config.value : "";
      }
    },
    loadTeamDiscountStatus() {
      this.$http.getCurrentTeam().then((res) => {
        const team = res.team || null;
        this.teamDiscountTeam = team;
        this.teamDiscountQualified = !!(team && team.qualified);
      }).catch(() => {});
    },
    selectDate() {
      this.show = true;
    },
    sureDate(e) {
      let currentMonth = e.getMonth() + 1;
      if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
      }
      let currentDay = e.getDate();
      if (currentDay < 10) {
        currentDay = "0" + currentDay;
      }
      this.endDate = `${e.getFullYear()}-${currentMonth}-${currentDay}`;
      this.show = false;
    },
    noDate() {
      this.show = false;
    },
    goBack() {
      this.$router.back();
    },
    changeuploads(id) {
      this.current = id;
    },
    handleTitleInput() {
      if (this.title.length >= 200) {
        Toast("论文题目不能超过200字符");
      }
    },
    handleAuthorInput() {
      if (!this.writerAnonymous) {
        this.preservedAuthor = this.author;
      }
      if (this.author.length >= 150) {
        Toast("作者不能超过150字符，应填此论文作者姓名，勿填参考文献作者");
      }
    },
    toggleAnonymous(event) {
      const nextChecked = event.target.checked;

      if (nextChecked) {
        this.preservedAuthor = this.author === "***" ? this.preservedAuthor : this.author;
        this.writerAnonymous = true;
        this.author = "***";
        return;
      }

      this.writerAnonymous = false;
      this.author = this.preservedAuthor || "";
    },
    confirmToggleCheckDbs() {
      const config = getCheckDbsConfig({
        id: this.msgs.id,
        cid: this.msgs.cid,
        name: this.msgs.banben,
      });

      if (!config) {
        return;
      }

      const checked = !this.checkDbsChecked;
      const actionText = checked ? "开启" : "取消";

      Dialog.confirm({
        title: "确认操作",
        message: `确认${actionText}${config.label}吗？`,
      })
        .then(() => {
          this.checkDbsChecked = checked;
          this.checkDbsValue = checked ? config.value : "";
        })
        .catch(() => {});
    },
    validateForm() {
      if (!this.title) {
        Toast.fail("论文标题不能为空");
        return false;
      }

      if (!this.author) {
        Toast.fail("作者姓名不能为空");
        return false;
      }

      if (this.title.length > 200) {
        Toast.fail("论文题目不能超过200字符");
        return false;
      }

      if (this.author.length > 150) {
        Toast.fail("作者不能超过150字符，应填此论文作者姓名，勿填参考文献作者");
        return false;
      }

      if (this.showPublishDate && !this.endDate) {
        Toast.fail("发表日期不能为空");
        return false;
      }

      if (this.current === 0 && this.content.length < 100) {
        Toast.fail("内容不少于100字");
        return false;
      }

      if (this.current === 1 && !this.file_id) {
        Toast.fail("请先上传文件");
        return false;
      }

      return true;
    },
    buildOrderPayload() {
      return {
        cid: this.msgs.id,
        title: this.title,
        writer: this.author,
        content: this.current === 0 ? this.content : "",
        file_id: this.current === 1 ? this.file_id : "",
        from: "H5",
        type: this.current === 0 ? "content" : "file",
        endDate: this.endDate,
        checkDbs: this.checkDbsValue,
        referer: window.location.host,
      };
    },
    handleDuplicateError(error, retryRequest) {
      const responseData = error && error.response && error.response.data ? error.response.data : null;
      const duplicate = responseData && responseData.duplicate_file ? responseData.duplicate_file : null;

      if (!duplicate) {
        return false;
      }

      if (duplicate.blocked) {
        Toast.fail((responseData && (responseData.message || responseData.msg)) || "该文件与上次提交信息一致，不能重复创建订单");
        return true;
      }

      if (duplicate.need_confirm) {
        Dialog.confirm({
          title: "重复文件提醒",
          message: duplicate.message || "该文件已被检测过，请确认文件是否选择正确，重复检测不支持退款",
          confirmButtonText: "确定检测",
          cancelButtonText: "重新选择",
        })
          .then(() => {
            retryRequest();
          })
          .catch(() => {});

        return true;
      }

      return false;
    },
    pushToPay(order) {
      this.$router.push({
        path: "/pay",
        query: {
          id: order.id,
          title: order.title,
          writer: order.writer,
          words: order.words,
          price: order.price,
          orderid: order.orderid,
          name: this.msgs.banben,
          timer: order.created_at,
          pricetype: this.msgs.pricetype,
        },
      });
    },
    toPay() {
      if (!this.validateForm() || this.submitLoading) {
        return;
      }

      this.submitLoading = true;
      const request = this.current === 0 ? this.$http.getTopaste : this.$http.getToUpload;
      const basePayload = this.buildOrderPayload();

      request(basePayload)
        .then((res) => {
          this.payMsg = res.data;
          this.pushToPay(this.payMsg);
        })
        .catch((error) => {
          if (this.handleDuplicateError(error, () => {
            this.submitLoading = true;
            request({
              ...basePayload,
              duplicate_confirmed: 1,
            })
              .then((res) => {
                this.payMsg = res.data;
                this.pushToPay(this.payMsg);
              })
              .catch(() => {
                Toast.fail("提交失败");
              })
              .finally(() => {
                this.submitLoading = false;
              });
          })) {
            return;
          }

          Toast.fail("提交失败");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    afterRead(fileWrapper) {
      const file = fileWrapper.file;
      const isValid = /\.(doc|docx)$/i.test(file.name || "");

      if (!isValid) {
        Toast("上传失败，仅支持doc、docx格式");
        return;
      }

      this.formData = new FormData();
      this.formData.append("file", file);
      this.uploadname = file.name;

      this.$http
        .getFileId(this.formData)
        .then((res) => {
          this.file_id = res.data.id;
          Toast("上传成功");
        })
        .catch(() => {
          Toast("上传失败，仅支持doc、docx格式");
        });
    },
  },
};
</script>

<style scoped>
.title {
  display: flex;
  background: #228ef7;
}
.pxui-color-red {
  color: #fb4e3a;
  font-size: 0.5rem;
}
.pxui-area h1 span {
  font-size: 0.3rem;
  color: #575757;
}
.pxui-area {
  padding: 0.3rem;
  background: #fff;
}
.pxui-area p {
  text-indent: 2em;
  line-height: 0.5rem;
  font-size: 0.33rem;
  color: #575757;
}
.team-discount-banner {
  margin: 0.2rem 0.24rem 0;
  padding: 0.18rem 0.22rem;
  border-radius: 0.16rem;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 0.27rem;
  line-height: 1.8;
}
.team-discount-banner.qualified {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46;
}
.lefticon {
  line-height: 0.8rem;
  padding: 0 0.3rem;
  color: #fff;
  font-size: 0.4rem;
}
.title p {
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  flex: 0.85;
}
.pxui-area h1 {
  line-height: 0.8rem;
}
.paper-information {
  margin: 0 0.3rem;
  margin-top: 0.3rem;
}
.info-row {
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
  border: 1px solid #e3eaf3;
  border-radius: 0.12rem;
  overflow: hidden;
  background: #fff;
  min-height: 0.95rem;
}
.info-row span {
  width: 1.56rem;
  min-width: 1.56rem;
  padding-left: 0.24rem;
  color: #333;
  font-size: 0.3rem;
  box-sizing: border-box;
  flex-shrink: 0;
  white-space: nowrap;
}
.info-row input {
  flex: 1;
  min-width: 0;
  border: none;
  font-size: 0.3rem;
  padding-right: 0.2rem;
}
.field-tip {
  color: #8a5a00;
  font-size: 0.24rem;
  line-height: 1.7;
  margin: -0.14rem 0 0.24rem 0.06rem;
}
.anonymous-toggle {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  white-space: nowrap;
  margin-right: 0.14rem;
  font-size: 0.26rem;
  color: #666;
}
.anonymous-toggle input {
  margin-right: 0.08rem;
  flex-shrink: 0;
}
.anonymous-toggle em {
  font-style: normal;
}
.checkdbs-box {
  display: flex;
  align-items: flex-start;
  padding: 0.22rem 0.2rem;
  margin-bottom: 0.28rem;
  border-radius: 0.16rem;
  background: #fffbea;
  border: 1px solid #f6dfa4;
}
.checkdbs-check {
  width: 0.3rem;
  height: 0.3rem;
  margin-top: 0.04rem;
  border-radius: 0.08rem;
  border: 1px solid #c7d2e1;
  background: #fff;
  position: relative;
  flex-shrink: 0;
}
.checkdbs-check.checked {
  background: #2563eb;
  border-color: #2563eb;
}
.checkdbs-check.checked::after {
  content: "";
  position: absolute;
  left: 0.1rem;
  top: 0.03rem;
  width: 0.08rem;
  height: 0.16rem;
  border-right: 0.03rem solid #fff;
  border-bottom: 0.03rem solid #fff;
  transform: rotate(45deg);
}
.checkdbs-body {
  padding-left: 0.16rem;
}
.checkdbs-title {
  font-size: 0.3rem;
  line-height: 1.5;
  color: #4b5563;
}
.checkdbs-tip {
  margin-top: 0.08rem;
  font-size: 0.24rem;
  color: #8b6b19;
}
.upload-tabs {
  margin-bottom: 0.4rem;
  display: flex;
}
.upload-tabs li {
  padding: 0.16rem 0.3rem;
  font-size: 0.3rem;
  color: #64748b;
  border-bottom: 2px solid transparent;
}
.upload-tabs li.active {
  color: #2563eb;
  font-weight: 600;
  border-bottom-color: #2563eb;
}
.upload-card {
  border-radius: 0.18rem;
  background: #f8fbff;
  border: 1px solid #dbeafe;
  overflow: hidden;
}
.upload-uploader {
  display: block;
}
.upload-panel {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.28rem 0.24rem;
}
.upload-panel-icon {
  width: 0.86rem;
  height: 0.86rem;
  border-radius: 0.2rem;
  background: linear-gradient(135deg, #228ef7 0%, #5db5ff 100%);
  color: #fff;
  font-size: 0.24rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 0.08rem 0.2rem rgba(34, 142, 247, 0.18);
}
.upload-panel-body {
  min-width: 0;
  flex: 1;
}
.upload-panel-title {
  font-size: 0.3rem;
  color: #1f2937;
  font-weight: 600;
  line-height: 1.5;
  word-break: break-word;
}
.upload-panel-tip {
  margin-top: 0.06rem;
  font-size: 0.24rem;
  color: #6b7280;
  line-height: 1.6;
}
.upload-panel-action {
  flex-shrink: 0;
  min-width: 1.58rem;
  height: 0.7rem;
  padding: 0 0.22rem;
  border-radius: 999px;
  background: rgba(34, 142, 247, 0.12);
  color: #228ef7;
  font-size: 0.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-file-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.2rem;
  padding: 0.18rem 0.24rem 0.22rem;
  border-top: 1px solid #dbeafe;
  background: #fff;
}
.upload-file-name {
  flex: 1;
  font-size: 0.25rem;
  color: #475569;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-file-status {
  flex-shrink: 0;
  color: #0f9d58;
  font-size: 0.24rem;
  font-weight: 600;
}
.wend-text {
  width: 100%;
  min-height: 5rem;
  padding: 0.24rem;
  box-sizing: border-box;
  border-radius: 0.16rem;
  border: 1px solid #e3eaf3;
  font-size: 0.3rem;
  line-height: 1.7;
}
.wjgs {
  font-size: 0.26rem;
  color: #666;
  margin-top: 0.16rem;
}
#subbutt {
  width: 100%;
  margin-top: 0.4rem;
  height: 0.92rem;
  border: none;
  border-radius: 0.16rem;
  background: #228ef7;
  color: #fff;
  font-size: 0.34rem;
}
#subbutt[disabled] {
  background: #9ca3af;
}

@media (max-width: 375px) {
  .info-row span {
    width: 1.42rem;
    min-width: 1.42rem;
    padding-left: 0.18rem;
    font-size: 0.28rem;
  }

  .info-row input {
    font-size: 0.28rem;
    padding-right: 0.12rem;
  }

  .anonymous-toggle {
    margin-right: 0.1rem;
    font-size: 0.24rem;
  }

  .anonymous-toggle input {
    margin-right: 0.05rem;
  }
}
</style>
